module.exports = __webpack_public_path__ + "img/amanali-regalo.ab1db9c3.jpg";